export default __webpack_public_path__ + "static/media/17-crafting-insights.a43f8563.png";